// assets and css
import './Home.css';
import Header from '../../shared/Header';
export default function Home(){ 
  
    return (
      <div>
      <Header/>
        
      </div>    
    );
  
}
